<a *ngIf="route as r; else plainText" [routerLink]="r" class="entity-link">{{ displayName }}</a>
<ng-template #plainText>{{ displayName }}</ng-template>
